export enum AssetStatusPillViews {
  DETAILS = 'details',
  TABLE = 'table',
}
